import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  carryRequest: null,
  admissionPerson: null
};

const slice = createSlice({
  name: 'copiedFormData',
  initialState,
  reducers: {
    setCarryRequestFormData(state, action) {
      state.carryRequest = action.payload;
    },
    deleteCarryRequestFormData(state) {
      state.carryRequest = null;
    },
    setAdmissionPersonFormData(state, action) {
      state.admissionPerson = action.payload;
    },
    deleteAdmissionPersonFormData(state) {
      state.admissionPerson = null;
    }
  }
});

export const reducer = slice.reducer;

export const copyCarryRequestFormData = (formData) => (dispatch) => {
  dispatch(slice.actions.setCarryRequestFormData(formData));
};

export const deleteCopiedCarryRequestFormData = () => (dispatch) => {
  dispatch(slice.actions.deleteCarryRequestFormData());
};

export const copyAdmissionPersonFormData = (formData) => (dispatch) => {
  dispatch(slice.actions.setAdmissionPersonFormData(formData));
};

export const deleteCopiedAdmissionPersonFormData = () => (dispatch) => {
  dispatch(slice.actions.deleteAdmissionPersonFormData());
};

export default slice;
